import { render, staticRenderFns } from "./ToBeConfiguredHotelDetail.vue?vue&type=template&id=69728d29&scoped=true"
import script from "./ToBeConfiguredHotelDetail.vue?vue&type=script&lang=js"
export * from "./ToBeConfiguredHotelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69728d29",
  null
  
)

export default component.exports